var _ellipse, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _g3, _g4, _g5, _path9, _path10, _path11, _path12, _g6, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMale7G(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 125,
    viewBox: "0 0 130 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.0357,
    cy: 61.5,
    rx: 60.0357,
    ry: 61.5,
    fill: "#E0DDFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_293_969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 12L115.5 37.5L117.797 46.61C124.858 74.608 110.826 103.639 84.5 115.5L62 108V12Z",
    fill: "#858181",
    fillOpacity: 0.3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.7506 42.7115C81.8378 42.0079 81.8052 41.3176 81.7051 40.6871C81.3932 38.722 79.5548 38.5321 77.9811 39.7497C77.4314 40.175 76.9604 40.6934 76.5895 41.2813L75 43.8008L74.5 52.3008L74.5325 52.291C75.1409 52.108 75.8 52.225 76.3083 52.6062L76.849 53.0117C77.2353 53.3015 78.1067 53.0271 78.5402 52.8145C78.8694 52.6531 78.8053 52.5761 79.0075 52.2702L79.3264 51.788C79.4088 51.6634 79.4781 51.5306 79.5332 51.3918L80.2171 49.6682C80.6005 48.3799 81.4439 45.185 81.7506 42.7115Z",
    fill: "#F4B09D",
    stroke: "#4F4848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5502 42.7115C34.463 42.0079 34.4955 41.3176 34.5956 40.6871C34.9076 38.722 36.746 38.5321 38.3197 39.7497C38.8694 40.175 39.3404 40.6934 39.7113 41.2813L41.3008 43.8008L41.8008 52.3008L41.7683 52.291C41.1599 52.108 40.5008 52.225 39.9925 52.6062L39.4518 53.0117C39.0655 53.3015 38.1941 53.0271 37.7606 52.8145C37.4313 52.6531 37.4955 52.5761 37.2933 52.2702L36.9744 51.788C36.892 51.6634 36.8227 51.5306 36.7676 51.3918L36.0837 49.6682C35.7003 48.3799 34.8569 45.185 34.5502 42.7115Z",
    fill: "#F4B09D",
    stroke: "#4F4848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8535 76.8356V63.5371L71.3061 63V65.1659V71.8114V77.6086V80.1898C71.3061 81.301 71.2069 82.4099 71.0097 83.5034L70.9004 84.1092C70.6609 85.4372 70.2351 86.7247 69.6355 87.9336L69.3332 88.5431C68.6124 89.9964 67.5853 91.2763 66.3225 92.2947C65.0595 93.3133 63.5907 94.0462 62.0172 94.4427L61.4343 94.5896C60.3522 94.8623 59.2406 95.0003 58.1247 95.0003H57.4498C55.4777 95.0003 53.5414 94.4731 51.8414 93.4734C50.5198 92.6962 49.3741 91.6528 48.4771 90.4094L47.8594 89.5531C47.1358 88.5502 46.5318 87.4663 46.0594 86.3234C45.2632 84.3971 44.8535 82.3332 44.8535 80.2489V76.8356Z",
    fill: "#F6C4A9",
    stroke: "#4F4848"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0427 55.1641L40.6716 53.8279C40.1382 51.9074 39.7542 49.9484 39.5232 47.9686L39.1035 44.3726V40.1213V39.7978C39.1035 36.6692 39.36 33.5459 39.8703 30.4593L40.637 27.7539L40.854 26.806C41.4639 24.1417 42.8073 21.7012 44.7321 19.7607C45.577 18.909 46.5233 18.1644 47.5497 17.5435L47.7675 17.4118C50.3759 15.834 53.3662 15 56.4147 15H58.2721H62.7371C64.3491 15 65.9494 15.274 67.4696 15.8104C70.9169 17.0268 73.7635 19.5238 75.4187 22.7832L75.7025 23.3422C76.0938 24.1128 76.4212 24.9142 76.6814 25.7383L76.9381 26.5516C77.9693 29.8187 78.3487 33.2566 78.0547 36.6699L77.824 39.3483L76.6739 50.9428L76.2905 53.6481C75.526 56.7309 74.4285 59.7213 73.0173 62.5666L72.8401 62.9237L70.3494 66.5506C69.7118 67.4792 68.9705 68.3322 68.1401 69.0933C66.1969 70.8742 63.8149 72.1061 61.2384 72.6627L60.8635 72.7437C60.1602 72.8956 59.4427 72.9722 58.7232 72.9722C55.4664 72.9722 52.32 71.7914 49.8675 69.6485L49.2356 69.0965C48.3619 68.3332 47.5756 67.4753 46.891 66.5387L45.8859 65.1636C43.6827 62.1492 42.0419 58.7616 41.0427 55.1641Z",
    fill: "#F6C4A9",
    stroke: "#4F4848"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9128 60.2453L52.9068 61.762H62.8745L61.0594 60.1936C60.49 59.7016 59.8033 59.365 59.0656 59.2163C58.5423 59.1107 58.0041 59.102 57.4776 59.1905L57.2855 59.2227C56.4238 59.3675 55.6098 59.7183 54.9128 60.2453Z",
    fill: "url(#paint0_linear_293_969)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9068 61.762L54.9128 60.2453C55.6098 59.7183 56.4238 59.3675 57.2855 59.2227L57.4776 59.1905C58.0041 59.102 58.5423 59.1107 59.0656 59.2163V59.2163C59.8033 59.365 60.49 59.7016 61.0594 60.1936L62.8745 61.762H52.5234",
    stroke: "#4F4848",
    strokeWidth: 0.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5898 54.0332V54.0332C56.9467 55.7919 59.6002 55.7919 60.957 54.0332V54.0332",
    stroke: "#4F4848",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3535 63.3105L56.533 63.4915C57.4573 64.4233 58.988 64.3386 59.8039 63.3105V63.3105",
    stroke: "#4F4848"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_293_969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.8828 43.7169C80.8828 44.2692 80.3828 42.7168 79.8828 42.7175C79.3828 42.2168 78.748 42.2684 78.748 41.7161C78.748 41.1638 79.3828 40.717 79.8828 41.2174C80.4351 41.2174 80.8828 43.1646 80.8828 43.7169Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5409 50.7164C77.3825 50.2168 77.7246 47.8711 77.8828 46.7168C77.8828 45.3711 78.5409 43.7168 79.0409 43.7168C80.0026 43.7168 79.9499 45.2251 79.7443 46.1645C79.329 48.0619 78.1838 50.7167 77.5409 50.7164Z",
    fill: "#6B6B6B"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_293_969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4453 43.136C38.4453 47.6367 39.9453 49.6367 39.9449 50.636C39.4453 51.6367 36.9449 46.9122 36.9449 46.636C36.9449 46.3599 35.9436 43.6366 36.9453 42.136C37.9436 41.6365 38.447 42.6368 38.4453 43.136Z",
    fill: "#606060"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_d_293_969)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 62.5,
    rx: 1,
    ry: 0.5,
    fill: "#DC2F2F",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_293_969)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1967 50.173C45.161 50.1056 41.9491 46.4755 42.0228 42.065C42.0363 41.2545 42.1599 40.474 42.3776 39.7404L39.5577 39.6932C39.0982 39.6856 38.732 39.3069 38.7397 38.8475C38.7474 38.3881 39.126 38.0218 39.5855 38.0295L42.7805 38.0829C42.8729 38.0845 42.9616 38.101 43.0442 38.1303C44.3424 35.7411 46.743 34.1558 49.4636 34.2013C52.3111 34.2489 54.7485 36.07 55.911 38.6875C56.5608 37.6614 57.6246 37.0004 58.816 37.0203C60.0376 37.0407 61.1012 37.7721 61.7096 38.864C62.9459 36.2435 65.4646 34.4687 68.3411 34.5168C71.062 34.5623 73.4085 36.2271 74.626 38.6588C74.7096 38.6323 74.7988 38.6187 74.8912 38.6203L77.1857 38.6586C77.6451 38.6663 78.0113 39.045 78.0036 39.5044C77.996 39.9638 77.6173 40.33 77.1579 40.3223L75.2382 40.2903C75.4312 41.0306 75.5286 41.8145 75.515 42.6247C75.4413 47.0352 72.1099 50.5559 68.0742 50.4885C64.0384 50.421 60.8265 46.791 60.9002 42.3805C60.9081 41.9074 60.9535 41.4445 61.0332 40.9952C61.0318 39.5387 60.0272 38.3719 58.7937 38.3513C57.656 38.3323 56.6803 39.2944 56.4964 40.5862C56.5984 41.1421 56.6474 41.7187 56.6376 42.3093C56.5639 46.7197 53.2325 50.2404 49.1967 50.173ZM49.219 48.842C52.5821 48.8982 55.3583 45.9643 55.4197 42.2889C55.4811 38.6135 52.8045 35.5885 49.4414 35.5323C46.0783 35.4761 43.3021 38.41 43.2407 42.0854C43.1793 45.7608 45.8558 48.7858 49.219 48.842ZM74.2971 42.6044C74.2357 46.2798 71.4595 49.2137 68.0964 49.1575C64.7333 49.1013 62.0567 46.0762 62.1181 42.4009C62.1795 38.7255 64.9557 35.7916 68.3188 35.8478C71.682 35.904 74.3585 38.929 74.2971 42.6044Z",
    fill: "#252C2F"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 33.5L44.9566 33.363C47.9132 32.476 51.0716 32.5239 54 33.5V33.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63 33.5L63.4566 33.363C66.4132 32.476 69.5716 32.5239 72.5 33.5V33.5",
    stroke: "black",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.8604 19.2929C77.6769 17.5328 78.6058 13.9641 77.5744 11.6486C76.3082 8.80581 64 18.9633 70.7843 9.69997C68.4633 10.8786 68.0418 12.2197 65.5 11.6486C63.0611 11.1007 59.1027 9.18582 56.5819 9.02711C52.4406 8.76637 48.4171 10.3918 45.5946 13.6682C45.0561 14.2932 44.6222 15.0079 44.2121 15.7322C43.8839 16.3118 43.5139 16.9336 43.3743 17.6017C43.3079 17.9193 43.4315 18.7031 43.282 18.9633C43.1203 19.2444 42.5106 19.5022 42.2507 19.7107C41.7243 20.1333 41.2682 20.6103 40.8464 21.1497C39.9506 22.2952 39.4575 23.4916 39.0428 24.9086C37.6642 29.6179 37.5473 35.2191 39.3295 39.8433C39.5671 40.4599 40.3033 41.7462 40.7361 40.4257C40.8216 40.1647 40.6237 39.2901 40.6242 39.0267C40.6257 38.0596 41.1302 31.6565 43.328 28.0695C44.0434 26.9019 47.3508 22.5297 48.0264 22.4946C48.3843 23.0965 52.0181 26.9422 61.4472 26.4915C65.7016 26.2882 68.9734 24.2655 69.759 23.3887C70.1046 25.3559 74.1244 28.301 74.737 29.5128C76.5065 33.0134 76.8989 40.2874 77.5744 40.2737C78.2499 40.2601 78.7348 38.4115 78.8737 38.0585C79.9058 35.4361 80.0815 32.1448 79.9714 29.3266C79.8278 25.6992 78.4129 21.7794 75.8604 19.2929Z",
    fill: "#28354B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71 66.0399C71 69.4867 67.2529 74.6671 61.0436 77.0586C58.9248 77.8746 56.5564 77.9135 54.433 77.1097C47.6976 74.5599 45 68.4954 45 65C46.0196 66.1774 50.6078 73.0842 57.2353 73.3194C64.8824 73.5909 68.9608 69.1597 71 66.0399Z",
    fill: "#655E5E",
    fillOpacity: 0.3
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_293_969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111 92.4991C104 106.5 83.054 123.352 59.6456 123.352C36.2372 123.352 14 105 9 92.5001C69.5 68.9899 19.5 66.4999 57 92.4991C95.5 70.0001 44 67 111 92.4991Z",
    fill: "#D9D9D9"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5646 77.9825L42.7237 74.17C43.291 73.6499 44.2086 73.9388 44.3756 74.6902L44.9497 77.2735C44.9828 77.4225 45.0496 77.562 45.145 77.6812L51 85L57.5 89.5L63.5 85L71.2747 77.7112C71.4215 77.5736 71.5233 77.395 71.567 77.1986L72.0815 74.8832C72.2574 74.0918 73.2523 73.8276 73.7976 74.4274L77.0173 77.969C77.3058 78.2864 77.3598 78.7524 77.1515 79.1273L70.6848 90.7674C70.3502 91.3697 69.521 91.4611 69.0632 90.9461L66 87.5L57.5 93.5L48.8571 87.5L45.9647 90.8745C45.5033 91.4128 44.644 91.3134 44.3177 90.6841L38.3526 79.1799C38.1445 78.7787 38.2314 78.2878 38.5646 77.9825Z",
    fill: "#E3E3E3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51 85L48.8571 87.5M51 85L57.5 89.5M51 85L45.145 77.6812C45.0496 77.562 44.9828 77.4225 44.9497 77.2735L44.3756 74.6902C44.2086 73.9388 43.291 73.6499 42.7237 74.17L38.5646 77.9825C38.2314 78.2878 38.1445 78.7787 38.3526 79.1799L44.3177 90.6841C44.644 91.3134 45.5033 91.4128 45.9647 90.8745L48.8571 87.5M48.8571 87.5L57.5 93.5M57.5 93.5L66 87.5M57.5 93.5V89.5M66 87.5L69.0632 90.9461C69.521 91.4611 70.3502 91.3697 70.6848 90.7674L77.1515 79.1273C77.3598 78.7524 77.3058 78.2864 77.0173 77.969L73.7976 74.4274C73.2523 73.8276 72.2574 74.0918 72.0815 74.8832L71.567 77.1986C71.5233 77.395 71.4215 77.5736 71.2747 77.7112L63.5 85M66 87.5L63.5 85M63.5 85L57.5 89.5",
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_293_969",
    x: 61,
    y: 11,
    width: 59.6133,
    height: 105.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_293_969"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_293_969",
    x: 73.5,
    y: 41,
    width: 11.3828,
    height: 17.7168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_293_969"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_293_969",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_293_969",
    x: 32.5,
    y: 42,
    width: 11.4453,
    height: 16.7754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_293_969"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_293_969",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_293_969",
    x: 53,
    y: 62,
    width: 10,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_293_969"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_293_969",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_293_969",
    x: 38.7402,
    y: 34.2012,
    width: 39.2637,
    height: 18.2891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_293_969"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_293_969",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_293_969",
    x: 8,
    y: 72.9219,
    width: 104,
    height: 51.4297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_293_969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_293_969",
    x1: 58.274,
    y1: 59.4431,
    x2: 58.274,
    y2: 62.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D1111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale7G);
export default __webpack_public_path__ + "static/media/Male 7 G.cf21a19878e8bf39e723537f9ddbbf41.svg";
export { ForwardRef as ReactComponent };